<template>
  <label
    class="container text-base"
    :class="{ activeButtonText: activeVal }"
  >
    <slot name="beforeText"></slot>
    <div>
      {{ item }}
      <p
        v-if="subText"
        class="text-1xs text-neutral-subtlest"
      >
        {{ subText }}
      </p>
    </div>
    <slot name="afterText"></slot>
    <input
      type="checkbox"
      :name="name"
      :value="item"
      @click="handleToggle(activeVal)"
      :checked="activeVal"
    />
    <span class="checkbox-checkmark"></span>
  </label>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    item: String,
    subText: String,
    activeItems: Array,
    handleSelect: {
      type: Function,
    },
    name: [String, Number],
    active: [Boolean, Object],
    label: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      activeVal: this.active,
    };
  },
  methods: {
    handleToggle(value) {
      let self = this;
      if (self.activeVal == true || self.activeVal == false) {
        console.log('its a bool');
        self.activeVal = !self.activeVal;
      } else {
        self.activeVal = !value;
      }
      console.log(self.activeVal);
      self.handleSelect(self.activeVal);
    },
  },
  watch: {
    active(newVal) {
      this.activeVal = newVal;
    },
  },
};
</script>

<style scoped>
/* Custom CSS for Checkboxes */
/* Template used from W3 schools https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox */
/* The container */
.container {
  @apply relative block flex h-12 cursor-pointer items-center py-4 pl-12 pr-4 text-left text-xs text-body-color sm:text-sm;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  @apply absolute h-0 w-0 cursor-pointer opacity-0;
}

/* Create a custom checkbox */
.checkbox-checkmark {
  @apply absolute left-2 top-0 h-6 w-6 rounded-md bg-off-white;
  top: 50%;
  transform: translate(0, -50%);
}

/* When the checkbox is checked, add a yellow background */
.container input:checked ~ .checkbox-checkmark {
  @apply bg-yellow-500;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkbox-checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkbox-checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkbox-checkmark:after {
  left: 9px;
  top: 3px;
  width: 9px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.activeButton {
  @apply flex flex-wrap rounded-md border-2 border-yellow-500 bg-white;
  border-color: #f8c617 !important;
  background-color: white !important;
}

.activeButtonText {
  @apply text-dark-gray;
}
</style>
